<div>
  <h3>Resources</h3>
  <button *ngIf="!viewMode" mat-raised-button color="primary" (click)="addResource()">Add Resource</button>
  <ul *ngIf="resources.length > 0">
    <li *ngFor="let resource of resources">
      <div>
        <a *ngIf="resource.isHyperlink" [href]="resource.path" target="_blank" class="resource-link">{{ resource.name }}</a>
        <a *ngIf="!resource.isHyperlink" (click)="onResourceClick($event, resource)" class="resource-link">
          {{ resource.name }}
        </a>
        <span> ({{ resource.resourceType }})</span>
      </div>
      <button *ngIf="!viewMode" mat-button color="primary" (click)="editResource(resource)">Edit</button>
      <button *ngIf="!viewMode" mat-button color="warn" (click)="deleteResource(resource.id)">Delete</button>
    </li>
  </ul>
  <p *ngIf="resources.length === 0">No resources available.</p>

  <!-- Resource Form -->
  <mat-card *ngIf="showResourceForm">
    <mat-card-title>{{ selectedResource ? 'Edit Resource' : 'Add Resource' }}</mat-card-title>
    <mat-card-content>
      <form [formGroup]="resourceForm" (ngSubmit)="saveResource()">
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Resource Type</mat-label>
          <input matInput formControlName="resourceType" />
        </mat-form-field>
        <mat-checkbox formControlName="isHyperlink" (change)="onIsHyperlinkChange()">Is Hyperlink</mat-checkbox>
        <div *ngIf="!resourceForm.get('isHyperlink')?.value">
          <label for="fileUpload">Upload File:</label>
          <input type="file" id="fileUpload" (change)="onFileSelected($event)" />
        </div>
        <mat-form-field appearance="fill">
          <mat-label>Path</mat-label>
          <input matInput formControlName="path" />
        </mat-form-field>
        <mat-card-actions>
          <button mat-raised-button color="primary" type="submit">Save</button>
          <button mat-raised-button color="warn" type="button" (click)="closeForm()">Cancel</button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
